import { useService } from "./service.js";
import { features } from "../Base/features.js";
import debounce from "../utils/debounce.js";
function createResizeService(breakpoints) {
  function updateProps() {
    props.width = window.innerWidth;
    props.height = window.innerHeight;
    props.ratio = window.innerWidth / window.innerHeight;
    props.orientation = "square";
    if (props.ratio > 1) {
      props.orientation = "landscape";
    }
    if (props.ratio < 1) {
      props.orientation = "portrait";
    }
    return props;
  }
  const onResize = debounce(() => {
    trigger(updateProps());
  });
  const { add, remove, has, trigger, props } = useService({
    props: {
      width: window.innerWidth,
      height: window.innerHeight,
      ratio: window.innerWidth / window.innerHeight,
      orientation: "square",
      get breakpoint() {
        return Object.keys(this.activeBreakpoints).toReversed().find((name) => this.activeBreakpoints[name]);
      },
      get breakpoints() {
        return Object.keys(this.activeBreakpoints);
      },
      get activeBreakpoints() {
        return Object.fromEntries(
          Object.entries(breakpoints ?? features.get("breakpoints")).map(([name, breakpoint]) => [
            name,
            window.matchMedia(`(min-width: ${breakpoint})`).matches
          ])
        );
      }
    },
    init() {
      window.addEventListener("resize", onResize);
    },
    kill() {
      window.removeEventListener("resize", onResize);
    }
  });
  return {
    add,
    remove,
    has,
    props: () => props
  };
}
const instances = /* @__PURE__ */ new Map();
function useResize(breakpoints) {
  const key = JSON.stringify(breakpoints);
  if (!instances.has(key)) {
    instances.set(key, createResizeService(breakpoints));
  }
  return instances.get(key);
}
export {
  useResize as default
};
//# sourceMappingURL=resize.js.map
